import axios from "axios";
import state from "@/store";

const getAllCouponsUsingWildCard = (params) => axios.post( state.getters.mainAppURL + "coupons/search_coupon_by_wild_card", params);

export {
    getAllCouponsUsingWildCard
}